import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import { CalendarIcon, CalendarIcon2 } from 'assets';
import dayjs from 'dayjs';
import React from 'react';

type Props = RangePickerProps & {};

const DateRangePicker: React.FC<Props> = ({ ...props }) => {
  return (
    <div className='relative flex h-10 items-center rounded-base border border-colorBorderInput'>
      <div className='absolute left-3'>
        <CalendarIcon2 color={'#1564e8'} />
      </div>
      <div className='absolute left-[calc(50%+13px)]'>
        <CalendarIcon2 color={'#1564e8'} />
      </div>
      <DatePicker.RangePicker allowClear={false} {...props} prefixCls='range-custom' />
    </div>
  );
};

export default DateRangePicker;
